import { ApplicationStore } from '../states'

export const updateLastLocation: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    lastLocation: payload,
  }
}

export const removeLastLocation: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.lastLocation
  return {
    ...newState,
  }
}
